function buyNowCartUrl(variantId, quantity, sellingPlan) {
  const qty = parseInt(quantity, 10);
  const safeQty = qty > 0 ? qty : 1;
  const id = String(variantId);
  const plan = sellingPlan && String(sellingPlan);
  // ponytail: /cart/id:qty ignores selling plans (Shopify). /cart/add keeps the plan; no /checkout so existing cart is not paid.
  if (plan) {
    return (
      '/cart/add?id=' +
      encodeURIComponent(id) +
      '&quantity=' +
      safeQty +
      '&selling_plan=' +
      encodeURIComponent(plan)
    );
  }
  return '/cart/' + id + ':' + safeQty;
}

if (typeof HTMLElement !== 'undefined') {
  class BuyNow extends HTMLElement {
    static get observedAttributes() {
      return ['disabled'];
    }

    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    connectedCallback() {
      this.setAttribute('role', 'button');
      this.syncA11y();
    }

    attributeChangedCallback() {
      this.syncA11y();
    }

    syncA11y() {
      const off = this.hasAttribute('disabled');
      this.setAttribute('tabindex', off ? '-1' : '0');
      this.setAttribute('aria-disabled', off ? 'true' : 'false');
    }

    handleKeydown(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      this.handleClick(e);
    }

    handleClick(e) {
      e.preventDefault();
      if (this.hasAttribute('disabled') || this.getAttribute('aria-disabled') === 'true') return;

      const form = this.closest('form');
      const addButton = form && form.querySelector('[name="add"]');
      if (addButton && (addButton.disabled || addButton.hasAttribute('disabled'))) return;

      const variantId =
        (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value) ||
        this.getAttribute('data-variant-id');
      const quantity = parseInt(
        (form && form.querySelector('[name="quantity"]') && form.querySelector('[name="quantity"]').value) ||
          this.getAttribute('data-quantity') ||
          1,
        10
      );
      const sellingPlan =
        (form && form.querySelector('[name="selling_plan"]') && form.querySelector('[name="selling_plan"]').value) ||
        '';

      if (!variantId) return;
      window.location = buyNowCartUrl(variantId, quantity, sellingPlan);
    }
  }

  if (!customElements.get('buy-now')) {
    customElements.define('buy-now', BuyNow);
  }
}

if (typeof window === 'undefined') {
  function eq(actual, expected) {
    if (actual !== expected) throw new Error('buy-now check failed: ' + actual + ' !== ' + expected);
  }
  eq(buyNowCartUrl('11', 2), '/cart/11:2');
  eq(buyNowCartUrl('11', '0'), '/cart/11:1');
  eq(buyNowCartUrl('11', 2, ''), '/cart/11:2');
  eq(buyNowCartUrl('11', 2, '99'), '/cart/add?id=11&quantity=2&selling_plan=99');
  console.log('buy-now check ok');
}
